import { TraceDiffItem } from '../../domain/Trace'

type DiffDataPartition = {
    faster: TraceDiffItem[]
    slower: TraceDiffItem[]
}

export const partitionDiffData = (diffData: TraceDiffItem[], limit: number, sortBy: 'wt' | 'excl_wt'): DiffDataPartition => {
    const faster = diffData
        .filter(stats => stats[sortBy] > 0)
        .sort(stats => -1 * stats[sortBy])
        .slice(0, limit)

    const slower = diffData
        .filter(stats => stats[sortBy] < 0)
        .sort(stats => stats[sortBy])
        .slice(0, limit)
        .map(stats => ({
            ...stats,
            wt: -1 * stats.wt,
            excl_wt: -1 * stats.excl_wt,
        }))

    return {
        faster,
        slower,
    }
}
